import { render, staticRenderFns } from "./ElaryWarningInfo.vue?vue&type=template&id=19bf91a9"
import script from "./ElaryWarningInfo.vue?vue&type=script&lang=js"
export * from "./ElaryWarningInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports